import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import COLORS from '../../constants/colors';
import { KickCounterContext } from '../../context/KickCounterContext';
import styles from './Home.module.css';
import sharedButtonStyles from '../../components/button/Button.module.css';
import Tooltip from '../../components/tooltip/Tooltip';
import { TOOLTIP } from '../../constants/strings';
import { COUNTER_MODE, ROUTE } from '../../constants/constants';
import useLogout from '../../hooks/useLogout';

const helpIcon = require('../../assets/icons/help_icon.svg').default;
const infoIcon = require('../../assets/icons/info_icon.svg').default;

export default function Home() {
  const { changeKickCounterMode } = useContext(KickCounterContext);
  const { logout } = useLogout();

  useEffect(() => {
    document.body.style.backgroundColor = COLORS.backgroundGreen;
    logout();
  }, []);

  return (
    <div className={styles.mainContainer}>
      <h3>Choose a counting method:</h3>
      <div className={styles.gridContainer}>
        <Link
          to={ROUTE.KICK_COUNTER}
          onClick={() => changeKickCounterMode(COUNTER_MODE.KICK)}
          className={classNames(styles.gridItem, sharedButtonStyles.FCButton)}
        >
          <img
            src={helpIcon}
            alt=""
            data-tip={TOOLTIP.HOME_10_MOVEMENTS}
            role="presentation"
          />
          <div>Track time to 10 movements</div>
        </Link>
        <Link
          to={ROUTE.KICK_COUNTER}
          onClick={() => changeKickCounterMode(COUNTER_MODE.TIME)}
          className={classNames(styles.gridItem, sharedButtonStyles.FCButton)}
        >
          <img
            src={helpIcon}
            alt=""
            data-tip={TOOLTIP.HOME_30_MIN}
            role="presentation"
          />
          <div>Track movements to 30 mins</div>
        </Link>
      </div>
      <div
        className={styles.methodTitle}
        data-tip={TOOLTIP.HOME_INFO}
      >
        <img src={infoIcon} alt="" />
        &nbsp;&nbsp;Why do I need to choose a method?
      </div>
      <Tooltip />
    </div>
  );
}
